module.exports = __webpack_public_path__ + "static/media/YM11_3.002c6cc5.jpg";